import ROUTES from 'routes';
import { apifyPath } from 'api/utils';
import { Route } from 'utils';

import ApiCrudStore2 from './ApiCrudStore2';

export default new ApiCrudStore2({
  route: ROUTES.API.ADVERTISERS,

  // extend: {
  //   fetchList () {
  //     return Promise.resolve({
  //       data: [{
  //         accountId: 0,
  //         appIds: [141, 142],
  //         id: 5,
  //         imageUrls: [],
  //         name: 'Playrix',
  //         status: 'ACTIVE',
  //       }],
  //     });
  //   },
  // },
});

export function getAdverPreview (id) {
  const route = apifyPath(ROUTES.API.ADVER_PREVIEW_PNG);
  return new Route(route).stringify({ params: { id } });
}
